export const formatProfileLabel = (name, functionalityType, monitor) =>
  `${name} (${monitor ? 'Monitor' : functionalityType.toUpperCase()})`;

export const parseProfileByAccountType = (profile, accountType) => {
  let labelString = profile.name;

  if (accountType !== 'carrier') {
    labelString = formatProfileLabel(
      profile.name,
      profile.functionality.functionality_type,
      profile.monitor
    );
  }

  return {
    value: profile.id,
    label: labelString,
    name: profile.name,
    type: profile.functionality.functionality_type,
    monitor: profile.monitor === true,
    profileRawObject: profile,
  };
};

export const packProfiles = (values) => {
  const profiles = [];
  if (values.ipsProfile !== 'none') {
    profiles.push({ id: values.ipsProfile });
  }
  if (values.otProfile !== 'none') {
    profiles.push({ id: values.otProfile });
  }
  if (values.applicationsProfile !== 'none') {
    profiles.push({ id: values.applicationsProfile });
  }
  if (values.dlpProfile !== 'none') {
    profiles.push({ id: values.dlpProfile });
  }
  if (values.casbProfile !== 'none') {
    profiles.push({ id: values.casbProfile });
  }
  if (values.webFilterProfile !== 'none') {
    profiles.push({ id: values.webFilterProfile });
  }
  if (values.antivirusProfile !== 'none') {
    profiles.push({ id: values.antivirusProfile });
  }
  return profiles;
};

export const getProfileById = (type, id, profiles) => {
  const profile = profiles[type]?.filter(
    (profile) => profile['id'] === parseInt(id)
  );

  if (profile && profile.length === 1) {
    return profile[0].id;
  }

  return 'none';
};

export const getProfileByType = (type, rule) => {
  const profile = rule?.profiles_processed?.find(
    (profile) => profile.functionality.name === type
  );

  return profile?.id || 'none';
};

export const findCurrentProfile = (profiles, profileId) => {
  const currentFirewallProfile = profiles.find(({ id }) => id === profileId);
  if (!currentFirewallProfile) {
    throw new Error(`Profile with ID ${profileId} not found.`);
  }
  return currentFirewallProfile;
};

export const groupProfilesByFunctionality = (
  profiles,
  currentFirewallProfile
) => {
  return profiles.reduce((acc, { id, name, functionality }) => {
    const { name: functionalityName, functionality_type: functionalityType } =
      functionality;

    if (!acc[functionalityName]) {
      acc[functionalityName] = [];
    }

    if (
      functionalityType ===
      currentFirewallProfile.functionality.functionality_type
    ) {
      acc[functionalityName].push({ id, name });
    }

    return acc;
  }, {});
};
